module.exports = __webpack_public_path__ + "static/media/15.7f9b6614.jpg";